import { useCallback } from 'react'

import { showSnackbar, type SnackbarSeverity } from '@/store/slices/uiSlice'
import { useAppDispatch } from '@/store'

export function useSnackbar() {
  const dispatch = useAppDispatch()
  const notify = useCallback(
    (message: string, severity: SnackbarSeverity = 'info') => {
      dispatch(showSnackbar({ message, severity }))
    },
    [dispatch],
  )
  return {
    notify,
    success: (m: string) => notify(m, 'success'),
    info: (m: string) => notify(m, 'info'),
    warning: (m: string) => notify(m, 'warning'),
    error: (m: string) => notify(m, 'error'),
  }
}
